import ModalBase from "./ModalBase";
import OrderConfirmationModalContent from "./content/OrderConfirmationModalContent";

const OrderConfirmationModal = () => {
	return (
		<ModalBase modalKey='order_confirmation'>
			<OrderConfirmationModalContent />
		</ModalBase>
	);
};

export default OrderConfirmationModal;